module.exports = __webpack_public_path__ + "static/credit-card-8a85623e56ee2429f4be9a83829c48c1.png";